/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import teaserImage from "../assets/img/teaser/Legalbird_Teaser_Main_500px.jpg";

import _find from "lodash/find";

// Key of list entry has to be unique and match the last part of the url of the respective page.
// Url defines (via router) which component will serve as lp template, see component Landingpage. It also serves landing page crawler list

export interface LandingPage {
  keyword: string;
  url: string;
  headline?: string;
  backgroundImage?: string;
}

export type LandingPagesList = Record<string, LandingPage>;

export const landingPagesList: LandingPagesList = {
  scheidung: {
    keyword: "Scheidung",
    headline: "Scheidung einfach & günstig",
    url: "/lp/scheidung",
    backgroundImage: teaserImage,
  },
  kuendigung: {
    keyword: "Kündigung",
    headline: "Kündigung erhalten? Jetzt Klage einreichen!",
    url: "/lp/kuendigung",
    backgroundImage: teaserImage,
  },
  "bussgeld-fahrverbot": {
    keyword: "Bußgeldbescheid & Fahrverbot",
    headline: "Jetzt Einspruch einlegen!",
    url: "/lp/bussgeld-fahrverbot",
  },
  verkehrsunfall: {
    keyword: "Verkehrsunfall",
    headline: "Schaden durch Verkehrsunfall erlitten?",
    url: "/lp/verkehrsunfall",
  },

  //partnerpages, keys not in use, keyword only for lp list
  //advocard
  "bussgeld-fahrverbot-advocard": {
    keyword: "Bußgeldbescheid & Fahrverbot Advocard",
    url: "/lp/advocard/bussgeld-fahrverbot",
  },
  "unterhalt-advocard": {
    keyword: "Unterhalt Advocard",
    url: "/lp/advocard/unterhalt",
  },
  "familienrecht-advocard": {
    keyword: "Familienrecht Advocard",
    url: "/lp/advocard/familienrecht",
  },
  "scheidung-advocard": {
    keyword: "Scheidung Advocard",
    url: "/lp/advocard/scheidung",
  },
  "todesfall-advocard": {
    keyword: "Todesfall Advocard",
    url: "/lp/advocard/todesfall",
  },
  "familienrecht-beratung-advocard": {
    keyword: "Familienrecht Beratung Advocard",
    url: "/lp/advocard/familienrecht-beratung",
  },
  "vertragsrecht-advocard": {
    keyword: "Vertragsrecht Advocard",
    url: "/lp/advocard/vertragsrecht",
  },
  "arbeitsrecht-advocard": {
    keyword: "Arbeitsrecht Advocard",
    url: "/lp/advocard/arbeitsrecht",
  },
  "zivilrecht-advocard": {
    keyword: "Zivilrecht Advocard",
    url: "/lp/advocard/zivilrecht",
  },
  "energie-hilfe-advocard": {
    keyword: "Advocard Energie Hilfe",
    url: "/lp/advocard/energie-hilfe",
  },
  "mietrecht-advocard": {
    keyword: "Advocard Mietrecht",
    url: "/lp/advocard/mietrecht",
  },
  "advocard-flexservice": {
    keyword: "FlexService",
    url: "/lp/advocard/flexservice",
  },

  //arag
  "bussgeld-fahrverbot-arag": {
    keyword: "Bußgeldbescheid & Fahrverbot Arag",
    url: "/lp/arag/bussgeld-fahrverbot",
  },
  "unterhalt-arag": {
    keyword: "Unterhalt Arag",
    url: "/lp/arag/unterhalt",
  },
  "familienrecht-arag": {
    keyword: "Familienrecht Arag",
    url: "/lp/arag/familienrecht",
  },
  "scheidung-arag": {
    keyword: "Scheidung Arag",
    url: "/lp/arag/scheidung",
  },
  "todesfall-arag": {
    keyword: "Todesfall Arag",
    url: "/lp/arag/todesfall",
  },
  "familienrecht-beratung-arag": {
    keyword: "Familienrecht Beratung Arag",
    url: "/lp/arag/familienrecht-beratung",
  },
  "kuendigung-arag": {
    keyword: "Kuendigung Arag",
    url: "/lp/arag/kuendigung",
  },

  //auxilia
  "familienrecht-beratung-auxilia": {
    keyword: "Familienrecht AUXILIA",
    url: "/lp/auxilia/familienrecht-beratung",
  },

  //deurag
  "familienrecht-beratung-deurag": {
    keyword: "Familienrecht Beratung Deurag",
    url: "/lp/deurag/familienrecht-beratung",
  },

  //huk
  "beamtenrecht-huk": {
    keyword: "Beamtenrecht HUK",
    url: "/lp/huk/beamtenrecht",
  },

  //wbs
  "kuendigung-wbs": {
    keyword: "Kündigungsschutzklage WBS",
    url: "/lp/wbs/kuendigung",
  },

  //lvm
  "familienrecht-lvm": {
    keyword: "Familienrecht LVM",
    url: "/lp/lvm/familienrecht-beratung",
  },
  "vertrags-zivilrecht-lvm": {
    keyword: "Vertrags- und Zivilrecht LVM",
    url: "/lp/lvm/vertragsrecht-zivilrecht",
  },
};

const stripTrailingSlash = (str: string): string => {
  return str.endsWith("/") ? str.slice(0, -1) : str;
};

export const getLpByLocation = (location: string) => {
  return _find(landingPagesList, ["url", stripTrailingSlash(location)]);
};
